import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { apiFetch } from "../services/apiClient";
import { formatDateTime } from "../utils/dateFormatter";

const OrderDetail = () => {
  const { id, hashcode } = useParams();
  const navigate = useNavigate();

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrderDetail();
  }, []);

  const fetchOrderDetail = async () => {
    try {
      const response = await apiFetch(`/my-orders/${id}`, {
        method: "GET",
      });

      if (response.success) {
        setOrder(response.data);
      }
    } catch (err) {
      console.error("Failed to load order detail", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="container mt-4 text-center">
        <div className="spinner-border" />
      </div>
    );
  }

  if (!order) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">Order not found</div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <button
        className="btn btn-link mb-3"
        onClick={() => navigate(`/${hashcode}/orders`)}
      >
        ← Back to Orders
      </button>

      <div className="card">
        <div className="card-header d-flex justify-content-between">
          <strong>Order #{order.order_number}</strong>
          <span
            className={`badge ${getStatusBadgeClass(
              order.status
            )} text-capitalize`}
          >
            {order.status}
          </span>
        </div>

        <div className="card-body">
          <p>
            <strong>Date:</strong> {formatDateTime(order.created_at)}
          </p>
          <p>
            <strong>Order Type:</strong> {order.order_type}
          </p>
          <p>
            <strong>Instructions:</strong> {order.special_instructions || "-"}
          </p>

          <hr />

          <h5>Items</h5>
          <ul className="list-group mb-3">
            {order.order_items.map((item) => {
              const price = Number(item.item_price_snapshot || 0);
              const total = price * item.quantity;

              return (
                <li
                  key={item.id}
                  className="list-group-item d-flex justify-content-between"
                >
                  <div>
                    <strong>{item.item_name}</strong> × {item.quantity}
                    <br></br>
                    {typeof item.special_instructions === "string" &&
                      item.special_instructions
                        .split("###")
                        .map((ins, index) => (
                          <span
                            key={index}
                            className="badge bg-secondary me-1 mt-1"
                          >
                            {ins}
                          </span>
                          
                        ))}
                  </div>

                  <div>₹{total.toFixed(2)}</div>
                </li>
              );
            })}
          </ul>

          {/* ===== BILL SUMMARY ===== */}
          <div className="border-top pt-3">
            <div className="d-flex justify-content-between">
              <span>Subtotal</span>
              <span>₹{Number(order.subtotal).toFixed(2)}</span>
            </div>

            <div className="d-flex justify-content-between">
              <span>Tax</span>
              <span>₹{Number(order.tax_total).toFixed(2)}</span>
            </div>

            <div className="d-flex justify-content-between fw-bold mt-2">
              <span>Grand Total</span>
              <span>₹{Number(order.grand_total).toFixed(2)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Status badge helper
const getStatusBadgeClass = (status) => {
  switch (status?.toLowerCase()) {
    case "completed":
      return "bg-success";
    case "preparing":
      return "bg-warning";
    case "pending":
      return "bg-info";
    case "cancelled":
      return "bg-danger";
    default:
      return "bg-secondary";
  }
};
export default OrderDetail;
